const GET_TRANSACTIONS = "/frontoffice/transaction";
const DOWNLOAD_TRANSACTIONS = "/frontoffice/transaction/download/filter";

export const TRANSACTION_ROUTES = {
  GET_TRANSACTIONS,
  DOWNLOAD_TRANSACTIONS,
};
